import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { OrderCollection, TransactionCollection } from './models';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';

@Injectable()
export class TransactionApi {
    public static getTransactionsByParams(_xmStore: XmStore, http: HttpClient): Observable<TransactionCollection> {
        return http.get('/account/payment/transactions?state=PENDING,PAST_DUE,ESTIMATED,PAID', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((apiResponse: ApiResponse) => TransactionCollection.create<TransactionCollection>(apiResponse || {}))
        );
    }

    public static getOrders(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<OrderCollection> {
        return http.get('/account/orders', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }),
            params: { legacy: 'true', ...params }
        }).pipe(
            map((response: ApiResponse) => OrderCollection.create<OrderCollection>({ orderTransactions: response }))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_TRANSACTIONS_BY_PARAMS] = TransactionApi.getTransactionsByParams;
ModelBase.fetchMapping[StoreAction.GET_ORDERS] = TransactionApi.getOrders;
